import { render } from "./Notificator.vue?vue&type=template&id=fae91092"
import script from "./Notificator.vue?vue&type=script&lang=js"
export * from "./Notificator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__